import { Badge, Box, Grid, GridItem, useBreakpointValue } from "@chakra-ui/react";
import React, { useState } from "react";
import ReactPlayer from "react-player/youtube";

import { normalizePhotoUrl } from "@/utilities/helpers/normalizePhotoUrl";
import { wrapBgImage } from "@/utilities/helpers/wrapBgImage";

import ModalGallery from "./ModalGallery";

const PhotoGallery = ({ imageUrls, ...props }) => {
    const [index, setIndex] = useState(0);
    const [isOpen, setIsOpen] = useState(false);
    const onClose = () => setIsOpen(false);
    const onOpen = () => setIsOpen(true);

    const getImage = (idx) => {
        if (imageUrls.length === 0)
            return "https://media.grupoguia.mx/assets/home-page/fichas/nodisponible.webp";
        // The cover photo (index 0) arrives JSON-escaped from the API. These
        // render as CSS backgrounds, where `\/` happens to be a valid escape
        // for `/`, so the gallery has been working by accident — normalize so
        // it doesn't break the day one of these becomes an <img>.
        const raw = normalizePhotoUrl(imageUrls[imageUrls.length >= idx + 1 ? idx : 0].url);
        return raw.includes("http")
            ? raw.replaceAll("wiggot.pro", "wiggot.mx")
            : `https://media.wiggot.mx/${raw}-m.jpg`;
    };

    const handleClick = () => {
        if (isGreaterThanMd) {
            onOpen();
        } else {
            if (index < imageUrls.length - 1) {
                setIndex(index + 1);
            } else {
                setIndex(0);
            }
        }
    };

    const isBetweenBaseAndMd = useBreakpointValue({ base: true, md: false });
    const isGreaterThanMd = useBreakpointValue({ base: false, md: true });

    return (
        <>
            <ModalGallery images={imageUrls} isOpen={isOpen} onClose={onClose} />
            <Grid
                w="100%"
                h="auto"
                templateColumns={{ base: "1rf", md: "repeat(4, 1fr)" }}
                templateRows={{ base: "1rf", md: "repeat(2, 50%)" }}
                gap="10px"
                {...props}
                onClick={handleClick}
                cursor="pointer"
            >
                {getImage(index).includes("https://youtu.be/") ? (
                    <GridItem colSpan="2" rowSpan="2">
                        <Box
                            borderTopLeftRadius={{ base: "5px", md: "10px" }}
                            borderBottomLeftRadius={{ base: "5px", md: "10px" }}
                            borderTopRightRadius={{ base: "5px", md: "0" }}
                            borderBottomRightRadius={{ base: "5px", md: "0" }}
                            alignItems="start"
                            justifyContent="start"
                            display="flex"
                            h="500px"
                        >
                            <ReactPlayer url={getImage(index)} loop width="200%" height="100%" />
                        </Box>
                    </GridItem>
                ) : (
                    <GridItem colSpan="2" rowSpan="2">
                        <Box
                            bgImage={wrapBgImage(getImage(index))}
                            bgPos="center"
                            bgSize="cover"
                            h="500px"
                            borderTopLeftRadius={{ base: "5px", md: "10px" }}
                            borderBottomLeftRadius={{ base: "5px", md: "10px" }}
                            borderTopRightRadius={{ base: "5px", md: "0" }}
                            borderBottomRightRadius={{ base: "5px", md: "0" }}
                            alignItems="end"
                            justifyContent="end"
                            display="flex"
                        >
                            {isBetweenBaseAndMd && (
                                <Badge
                                    padding="5px 30px"
                                    borderRadius="full"
                                    color="#fff"
                                    bg="rgba(0,0,0, 0.6)"
                                    fontSize="12px"
                                    fontWeight="400"
                                    marginRight="5"
                                    marginBottom="5"
                                >
                                    {index + 1} / {imageUrls.length}
                                </Badge>
                            )}
                        </Box>
                    </GridItem>
                )}
                {isGreaterThanMd && (
                    <>
                        <GridItem>
                            <Box
                                bgImage={wrapBgImage(getImage(1))}
                                bgPos="center"
                                bgSize="cover"
                                h="240px"
                            />
                        </GridItem>
                        <GridItem>
                            <Box
                                bgImage={wrapBgImage(getImage(2))}
                                bgPos="center"
                                bgSize="cover"
                                h="240px"
                                borderTopRightRadius="10px"
                            />
                        </GridItem>
                        <GridItem>
                            <Box
                                bgImage={wrapBgImage(getImage(3))}
                                bgPos="center"
                                bgSize="cover"
                                h="240px"
                            />
                        </GridItem>
                        <GridItem>
                            <Box
                                bgImage={wrapBgImage(getImage(4))}
                                bgPos="center"
                                bgSize="cover"
                                h="240px"
                                borderBottomRightRadius="10px"
                                display="flex"
                                alignItems="center"
                                justifyContent="center"
                            >
                                <Box
                                    p="10px 20px"
                                    borderRadius="full"
                                    color="#fff"
                                    bg="rgba(0,0,0, 0.6)"
                                    fontSize="12px"
                                    fontWeight="400"
                                    _hover={{ backgroundColor: "#000" }}
                                >
                                    VER MÁS FOTOS
                                </Box>
                            </Box>
                        </GridItem>
                    </>
                )}
            </Grid>
        </>
    );
};

export default PhotoGallery;
